import React from "react";

const About = ({ ...props }) => {
  return (
    <div>
      <div>
        <h2>About MIDAS 3</h2>
        <h4>Mobil Integrated Data Aquisition System</h4>
        <h4>Copyright EMTEC IT 2023</h4>
      </div>
      <div>
        MIDAS is a custom developed Laboratory Information Management System
      </div>
      <div>
        <h3>Development Team</h3>
        <h4>System Architects</h4>
        <p>Eric Delich<br/>
        </p>
        <h4>Product Owner</h4>
        <p>Jatin K Bhatt</p>
        <h4>Developers</h4>
        <p>Leonardo Oliveira<br />
          Basit Mohammed<br />
          Henrique Delavi Daum<br />
          Nelson B Sebastiani<br/>
          Gary Lyons<br/>
          Moacir Moraes</p>
        <h4>Scrum Master</h4>
        <p>Elisa B Moreira</p>
      </div>
    </div>
  );
};

export default About;